import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { PublicationDeletionFormComponent } from './publication-deletion-form.component';

@NgModule({
  declarations: [
    PublicationDeletionFormComponent
  ],
  imports: [
    CommonModule,
    ErrorsExpansionPanelModule,
    FormsModule,
    LoaderModule,
    MatButtonModule,
    MatSnackBarModule
  ],
  exports: [
    PublicationDeletionFormComponent
  ]
})
export class PublicationDeletionFormModule { }
